import AxiosConfig from '../../../config/AxiosConfig';

const useFinalizeSavDecomposition = () => {
  const finalizeSavDecomposition = async (id) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/savdraft/${id}/finalizeDecomposition`
      )
        .call()
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to finalize SAV after decomposition:', err);
      throw new Error(`finalizeSavDecomposition failed: ${err?.message}`);
    }
  };

  return {
    finalizeSavDecomposition,
  };
};

export default useFinalizeSavDecomposition;
